import React from "react"
import { RouteComponentProps } from "@reach/router"
import { IFrame } from "../../integration/iframe"

interface Props extends RouteComponentProps {
  id?: string
}

export const ReferralsCustomerBehaviourNotes: React.FC<Props> = ({ id = `` }) => (
  <>
    <IFrame path={`referrals/${id}/customerBehaviourNotes`} />
  </>
)

ReferralsCustomerBehaviourNotes.defaultProps = {
  id: ``,
}
